import { useCharacterStore } from '@/engine/state';
import { StatBar } from '@/components/ui/StatBar';

export function CharacterSummary() {
  const personaje = useCharacterStore((s) => s.personaje);

  return (
    <div className="p-5 scroll-y h-full min-h-0">
      <header>
        <p className="fluid-xs uppercase tracking-widest text-ash-500 font-ui">
          Personaje
        </p>
        <h2 className="fluid-lg text-display text-ash-100 mt-1 truncate">
          {personaje.nombre}
        </h2>
        <p className="fluid-xs text-ash-500 mt-1">
          Nivel {personaje.nivel} · XP {personaje.xp}/{personaje.xpParaSiguienteNivel}
        </p>
      </header>

      <div className="mt-5 space-y-3">
        <StatBar
          label="Vida"
          valor={personaje.stats.vida}
          max={personaje.stats.vidaMax}
          color="ember"
        />
        <StatBar
          label="Mana"
          valor={personaje.stats.mana}
          max={personaje.stats.manaMax}
          color="mystic"
        />
      </div>

      <div className="mt-5 grid grid-cols-2 gap-y-1.5 gap-x-3 fluid-sm">
        <StatRow label="Empatía" valor={personaje.stats.empatia} />
        <StatRow label="Valentía" valor={personaje.stats.valentia} />
        <StatRow label="Astucia" valor={personaje.stats.astucia} />
        <StatRow label="Resistencia" valor={personaje.stats.resistencia} />
        <StatRow label="Vínculo" valor={personaje.stats.vinculo} />
      </div>

      {personaje.puntosSkillDisponibles > 0 && (
        <div className="mt-5 rounded border border-moss-700/60 bg-moss-900/40 px-3 py-2 fluid-xs text-moss-200 font-ui">
          {personaje.puntosSkillDisponibles} punto{personaje.puntosSkillDisponibles !== 1 && 's'} de habilidad disponible{personaje.puntosSkillDisponibles !== 1 && 's'}
        </div>
      )}
    </div>
  );
}

function StatRow({ label, valor }: { label: string; valor: number }) {
  return (
    <div className="flex justify-between text-ash-300 font-ui">
      <span className="text-ash-500">{label}</span>
      <span className="tabular-nums">{valor}</span>
    </div>
  );
}
